export class ColorDisplay {
    
}